// Setup an object with keys that can be accessed for shortcodes
// e.g. {{dataStore.key_name}}

function setupDataStore(dataStoreItems){
  const dataStore = dataStoreItems.reduce((acc, item) => {
    acc[item.key] = item.value
    return acc
  }, {})

  return dataStore
}

export default setupDataStore
